import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StringInteger"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.5 9H16.5V10.5H19.5V12H17.25V13.5H19.5V15H16.5V16.5H19.5C19.8977 16.4995 20.2789 16.3413 20.5601 16.0601 20.8413 15.7789 20.9995 15.3977 21 15V10.5C20.9995 10.1023 20.8414 9.72105 20.5602 9.43984 20.279 9.15864 19.8977 9.00046 19.5 9zM14.25 16.5H9.75V13.5C9.7504 13.1023 9.90856 12.721 10.1898 12.4398 10.471 12.1586 10.8523 12.0004 11.25 12H12.75V10.5H9.75V9H12.75C13.1477 9.00046 13.529 9.15864 13.8102 9.43984 14.0914 9.72105 14.2495 10.1023 14.25 10.5V12C14.2495 12.3977 14.0914 12.779 13.8102 13.0602 13.529 13.3414 13.1477 13.4995 12.75 13.5H11.25V15H14.25V16.5zM6 15V9H4.5V9.75H3V11.25H4.5V15H3V16.5H7.5V15H6z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StringInteger.vue"]]);
